/**
 * Component Entry
 *
 */

import Input from './Input'
export default Input
export * from './Input'
